import ReactDOM from 'react-dom';
import { StoreProvider } from 'easy-peasy';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import store from '@store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@translate';

ReactDOM.render(
  <StoreProvider store={store}>
    <GoogleReCaptchaProvider 
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_KEY || ''}
      scriptProps={{
        async: true,
        defer: false,
        appendTo: 'head',
      }}
    >
      <App />
    </GoogleReCaptchaProvider>
  </StoreProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
